import React from 'react';
import { Text, View } from 'react-native';
import i18n from './../util/i18n';
import { Autocomplete, Button, Card, Chip, FormHelperText, Grid2, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { callbackSpotify, connectToSpotify, spotifyConnectionStatus } from '../services/spotify.service';
import {
    loadAliases as loadAliasesMethod,
    removeSuggestionsWithSimilarAnswers as removeSuggestionsWithSimilarAnswersMethod,
    removeSuggestions as removeSuggestionsMethod,
    getRemovedKeywords
} from '../services/elastic.service';
import { resetPoints as resetPointsMethod } from '../services/points.service';
import { getSetting, putSetting } from '../services/settings.service';
import { convertHourMinuteSecondsToSeconds, convertSecondsToHourMinuteSeconds } from '../services/common.service';

i18n.locale = navigator.language;

class Settings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            spotify_status: null,
            timeline: {},
            time: '',
            keywords: [],
            removed_suggestions_history: []
        };
    }

    async setStateAsync(newState) {
        return new Promise((resolve) => {
            this.setState(newState, resolve);
        });
    }

    async componentDidMount() {
        // get the url params if exists
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code) {
            await this.callbackSpotify(code);
            // refresh the page without the code
            window.history.replaceState({}, document.title, "/Settings");
        }
        this.setSpotifyConnectionStatus();
        this.setTimelineSettings();
        this.setElasticRemovedSuggestionsHistory();
    }

    connectSpotify = async () => {
        let connect_to_spotify_res = await connectToSpotify();
        if (connect_to_spotify_res?.url) {
            window.location.href = connect_to_spotify_res.url;
        }
    }

    setSpotifyConnectionStatus = async () => {
        let spotify_connection_status_res = await spotifyConnectionStatus();
        if (spotify_connection_status_res?.error) {
            console.error('Error in setSpotifyConnectionStatus: ', spotify_connection_status_res?.error);
            spotify_connection_status_res = null;
        }
        this.setState({ spotify_status: spotify_connection_status_res });
    }

    callbackSpotify = async (code) => {
        await callbackSpotify(code);
        this.setSpotifyConnectionStatus();
    }

    loadAliases = async () => {

        let confirm = window.confirm(i18n.t('are_you_sure'));
        if (!confirm) {
            return;
        }

        let res = await loadAliasesMethod();
        console.log('loadAliases: ', res);
    }

    removeSuggestionsWithSimilarAnswers = async () => {

        let confirm = window.confirm(i18n.t('are_you_sure'));
        if (!confirm) {
            return;
        }

        let res = await removeSuggestionsWithSimilarAnswersMethod();
        console.log('removeSuggestionsWithSimilarAnswers: ', res);
    }

    resetPoints = async () => {

        let confirm = window.confirm(i18n.t('are_you_sure'));
        if (!confirm) {
            return;
        }

        let res = await resetPointsMethod();
        console.log('resetPoints: ', res);
    }
    
    removeSuggestions = async () => {

        let confirm = window.confirm(i18n.t('are_you_sure'));
        if (!confirm) {
            return;
        }

        let res = await removeSuggestionsMethod({
            keywords: this.state?.keywords || []
        });
        if (!res?.success) {
            alert(i18n.t('something_went_wrong'));
            return;
        }

        this.setState({ keywords: [] });
        // refresh the removed suggestions history
        this.setElasticRemovedSuggestionsHistory();
    }

    // -------------  Timeline Settings -------------

    saveTimelineSettings = async () => {
        try {
            let update_res = await putSetting('timeline', this.state?.timeline);
            console.log('update_res: ', update_res);
        } catch (error) {
            console.error('Error in saveTimelineSettings: ', error);
        }
    }

    setTimelineSettings = async () => {
        let timeline_settings = await getSetting('timeline');
        if (timeline_settings?.setting?.data) {
            this.setState({ timeline: {
                ...timeline_settings.setting.data,
                song_start_time: await convertSecondsToHourMinuteSeconds(timeline_settings.setting.data?.song_start_time || 0),
                chorus_start_time: await convertSecondsToHourMinuteSeconds(timeline_settings.setting.data?.chorus_time || 0),
            } });
        }
    }

    setElasticRemovedSuggestionsHistory = async () => {
        let removed_suggestions_history = await getRemovedKeywords();
        this.setState({ removed_suggestions_history: removed_suggestions_history?.keywords || [] });
    }

    onTimelineChange = async () => {
        // let song_start_time = await convertHourMinuteSecondsToSeconds(this.state?.timeline?.song_start_time);
        let jump_to_chorus = await convertHourMinuteSecondsToSeconds(this.state?.timeline?.jump_to_chorus);
        jump_to_chorus = isNaN(jump_to_chorus) ? 0 : Math.max(0, jump_to_chorus);

        // let total_time = jump_to_chorus + chorus_time;
        let time = await convertHourMinuteSecondsToSeconds(this.state?.timeline?.time);

        let chorus_time = time - jump_to_chorus;
        chorus_time = isNaN(chorus_time) ? 0 : Math.max(0, chorus_time);

        this.setState({ timeline: {
            ...this.state.timeline,
            chorus_time: chorus_time
        }});
    }

    // --------- End of Timeline Settings ---------

    render() {
        return (
            <View>

                {/* Spotify */}
                <Card style={{ padding: 10, marginBottom: 10 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                        <Text style={{ padding: 10, fontSize: 25 }}>
                            {i18n.t('spotify')}
                        </Text>
                        <Button
                            size='small'
                            variant='contained'
                            // icon
                            startIcon={<LinkIcon />}
                            onClick={() => {
                                this.connectSpotify();
                            }}
                        >
                            {i18n.t('connect')}
                        </Button>
                    </View>


                    {(this.state?.spotify_status) ? (
                        <View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                                <Text style={{ padding: 10, fontSize: 15 }}>
                                    {i18n.t('existing_connection_details')}
                                </Text>
                            </View>
                            <View>
                                <TableContainer>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>{i18n.t('devices')}</TableCell>
                                                <TableCell>{JSON.stringify(this.state.spotify_status?.devices)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{i18n.t('profile')}</TableCell>
                                                <TableCell>{JSON.stringify(this.state.spotify_status?.profile)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>{i18n.t('scope')}</TableCell>
                                                <TableCell>{this.state.spotify_status?.scope}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </View>
                        </View>
                    ) : null}
                </Card>

                <Card style={{ padding: 10, marginBottom: 10 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                        <Text style={{ padding: 10, fontSize: 25 }}>
                            {i18n.t('timeline')}
                        </Text>
                    </View>

                    <Stack spacing={2}>
                        {/* Label */}
                        <Text>{i18n.t('timeline')}</Text>
                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('song_start_time')}
                            label={i18n.t('song_start_time')}
                            value={this.state?.timeline?.song_start_time || ''}
                            onChange={async (e) => {
                                await this.setStateAsync({ timeline: { ...this.state.timeline, song_start_time: e.target.value } });
                                this.onTimelineChange();
                            }}
                        />
                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('jump_to_chorus')}
                            label={i18n.t('jump_to_chorus')}
                            value={this.state?.timeline?.jump_to_chorus || ''}
                            onChange={async (e) => {
                                await this.setStateAsync({ timeline: { ...this.state.timeline, jump_to_chorus: e.target.value } });
                                this.onTimelineChange();
                            }}
                        />
                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('chorus_start_time')}
                            label={i18n.t('chorus_start_time')}
                            value={this.state?.timeline?.chorus_start_time || ''}
                            onChange={async (e) => {
                                await this.setStateAsync({ timeline: { ...this.state.timeline, chorus_start_time: e.target.value } });
                                this.onTimelineChange();
                            }}
                        />
                        {/* <TextField
                            disabled
                            fullWidth
                            size='small'
                            placeholder={i18n.t('chorus_time')}
                            label={i18n.t('chorus_time')}
                            value={this.state?.timeline?.chorus_time || '0'}
                            onChange={async (e) => {
                                await this.setStateAsync({ timeline: { ...this.state.timeline, chorus_time: e.target.value } });
                                this.onTimelineChange();
                            }}
                        /> */}

                        {/* Time */}
                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('time')}
                            label={i18n.t('time')}
                            value={this.state?.timeline?.time || ''}
                            onChange={async (e) => {
                                // this.setState({ time: e.target.value });
                                await this.setStateAsync({ timeline: { ...this.state.timeline, time: e.target.value } });
                                this.onTimelineChange();
                            }}
                        />

                        <TextField
                            fullWidth
                            size='small'
                            placeholder={i18n.t('solution_display_time')}
                            label={i18n.t('solution_display_time')}
                            value={this.state?.timeline?.solution_display_time || ''}
                            onChange={async (e) => {
                                await this.setStateAsync({ timeline: { ...this.state.timeline, solution_display_time: e.target.value } });
                                this.onTimelineChange();
                            }}
                        />

                        

                        <Button
                            size='small'
                            variant='contained'
                            onClick={() => {
                                this.saveTimelineSettings();
                            }}
                        >
                            {i18n.t('save')}
                        </Button>

                    </Stack>

                </Card>

                {/* Elastic */}
                <Card style={{ padding: 10 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                        <Text style={{ padding: 10, fontSize: 25 }}>
                            {i18n.t('elastic')}
                        </Text>
                    </View>

                    <Stack spacing={2} direction={'row'} sx={{ mb: 2, alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>
                            <Autocomplete
                                fullWidth
                                multiple
                                freeSolo
                                size='small'
                                id="keywords"
                                disableClearable
                                options={[]}
                                value={this.state.keywords}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size='small'
                                        label={i18n.t('keywords')}
                                        placeholder={i18n.t('keywords')}
                                        slotProps={{
                                            input: {
                                                ...params.InputProps,
                                                type: 'search',
                                            },
                                        }}
                                    />
                                )}
                                onChange={(event, value) => {
                                    this.setState({ keywords: value });
                                }}
                            />
                            {/* <FormHelperText id="outlined-weight-helper-text">
                                {i18n.t('if_no_keywords_are_entered_then_all_suggestions_from_history_will_be_removed')}
                            </FormHelperText> */}
                        </div>
                        <div>
                            <Button
                                fullWidth
                                // size='small'
                                variant='contained'
                                onClick={() => {
                                    this.removeSuggestions();
                                }}
                                disabled={!this.state?.keywords?.length}
                            >
                                {i18n.t('remove_suggestions')}
                            </Button>
                        </div>
                        <div>
                            <Button
                                fullWidth
                                // size='small'
                                variant='contained'
                                onClick={() => {
                                    this.removeSuggestions();
                                }}
                                disabled={this.state?.keywords?.length > 0}
                            >
                                {i18n.t('remove_all_suggestions_from_history')}
                            </Button>
                        </div>
                    </Stack>

                    <Stack spacing={2} direction={'row'}>
                        <Button
                            size='small'
                            variant='contained'
                            onClick={() => {
                                this.loadAliases();
                            }}
                        >
                            {i18n.t('load_aliases')}
                        </Button>

                        <Button
                            size='small'
                            variant='contained'
                            onClick={() => {
                                this.removeSuggestionsWithSimilarAnswers();
                            }}
                        >
                            {i18n.t('remove_suggestions_with_similar_answers')}
                        </Button>

                        {/* <Button
                            size='small'
                            variant='contained'
                            onClick={() => {
                                this.resetPoints();
                            }}
                        >
                            {i18n.t('reset_points')}
                        </Button> */}
                    </Stack>

                    {(this.state?.removed_suggestions_history?.length) ? (
                        <Stack spacing={2} direction={'column'} sx={{ mt: 2 }}>
                            <Text style={{ fontWeight: 'bold' }}>{i18n.t('removed_suggestions_history')}</Text>
                            <Grid2 container spacing={1}>
                                {this.state.removed_suggestions_history.map((suggestion, index) => (
                                    <Chip key={index} label={suggestion} />
                                ))}
                            </Grid2>
                        </Stack>
                    ) : null}

                </Card>


                
            </View>
        )
    }
}

export default Settings;
